module.exports = {
  title: '共创家—商家端管理',
  baseUrl: 'https://applet1.jifenxitong.com/', // 测试项目地址
  baseApi: 'https://applet1.jifenxitong.com/admin', // 测试api请求地址
  baseApiApplet: 'https://applet1.jifenxitong.com/applet',
  APPID: 'wx489c93ebee8842f2',
  APPSECRET: '',
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
}
